export default ($http) => ({
  postError (code) {
    return $http.post(`http-error/${code}`)
  },
  getError (code) {
    return $http.get(`http-error/${code}`)
  },
  putError (code) {
    return $http.put(`http-error/${code}`)
  },
  deleteError (code) {
    return $http.delete(`http-error/${code}`)
  }
})
